export enum ForbiddenErrorMessageOptions {
  Suspended = 'Suspended',
  CredentialsError = 'CredentialsError',
  Client = 'Client',
  Agent = 'Agent'
}
